"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

var _Checked = _interopRequireDefault(require("../images/icons/Checked"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const ListContainer = _styledComponents.default.ul.withConfig({
  displayName: "StepProgressBar__ListContainer",
  componentId: "design-system__eta47h-0"
})(["list-style:none;padding:0 16px;box-sizing:border-box;display:flex;justify-content:space-between;width:100%;"]);

const Step = _styledComponents.default.li.withConfig({
  displayName: "StepProgressBar__Step",
  componentId: "design-system__eta47h-1"
})(["position:relative;width:100%;font-family:", ";font-weight:bold;color:", ";font-size:", ";line-height:22px;display:flex;flex-direction:column;align-items:center;> svg{circle{fill:", ";}path{stroke:", ";}}&:first-child{align-items:flex-start;flex-basis:50%;flex-shrink:1;&:before{display:none;}&:after{left:21px;width:calc(100% - 21px);}}&:last-child{align-items:flex-end;flex-basis:50%;flex-shrink:1;&:before{right:21px;width:calc(100% - 21px);}&:after{display:none;}}:before,:after{content:\"\";height:2px;width:calc(50% - 9px);background-color:", ";position:absolute;top:12px;}:before{right:calc(50% + 10px);}:after{left:calc(50% + 10px);}&.isActived{:before{background-color:", ";}:after{background-color:", ";}svg{circle{fill:", ";}path{stroke:", ";}}}"], _BaseTheme.default.type.family.content, _BaseTheme.default.colors.textgray, _BaseTheme.default.type.size.small, _BaseTheme.default.colors.lightergray, _BaseTheme.default.colors.lightergray, _BaseTheme.default.colors.lightergray, _BaseTheme.default.colors.green, props => props.isCurrentStep ? _BaseTheme.default.colors.lightergray : _BaseTheme.default.colors.green, _BaseTheme.default.colors.green, _BaseTheme.default.colors.green);

const StepProgressBar = _ref => {
  let {
    steps,
    currentStepIndex
  } = _ref,
      props = _objectWithoutProperties(_ref, ["steps", "currentStepIndex"]);

  const isValidIndex = currentStepIndex <= steps.length - 1;
  return /*#__PURE__*/_react.default.createElement(ListContainer, props, steps.map((label, index) => /*#__PURE__*/_react.default.createElement(Step, {
    key: label,
    isCurrentStep: currentStepIndex === index,
    className: currentStepIndex >= index && isValidIndex ? 'isActived' : ''
  }, /*#__PURE__*/_react.default.createElement(_Checked.default, null), label)));
};

StepProgressBar.defaultProps = {
  steps: [],
  currentStepIndex: -1
};
StepProgressBar.propTypes = {
  steps: _propTypes.default.arrayOf(_propTypes.default.string),
  currentStepIndex: _propTypes.default.number
};
var _default = StepProgressBar;
exports.default = _default;